import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import RouteBloc from "../../../bloc/route_bloc";
import App_header from "../../component/app_header/app_header";
import App_sidebar from "../../component/app_sidebar_mrtt/app_sidebar";
import Config from "../../../Config";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import "./quotation_screen.css";
import { setFilterBy } from "../../../data/redux/reducers/filterReducer";
import BaseScreen from "../base/base_screen/base_screen";
import App_header_title_simple from "../../component/app_header_title/app_header_title_simple";
import App_daterange_filter from "../../component/app_filters/app_daterange_filter";
import App_dropdown_filter from "../../component/app_filters/app_dropdown_filter";
import { ReactComponent as PlusIcon } from "../../../Plus.svg";
import { ReactComponent as LeftArrowIcon } from "../../../Arrow_Left.svg";
import { ReactComponent as RightArrowIcon } from "../../../Arrow_Right.svg";
import { ReactComponent as ThreeDotsIcon } from "../../../ThreeDots.svg";
import { Checkbox, Dropdown, Menu, Pagination } from "antd";
import GeneralBloc from "../../../bloc/general_bloc";
import AppDropdownFilter3 from "../../component/app_filters/app_dropdown_filter3";
import AppDropdownSort from "../../component/app_filters/app_dropdown_sort";
import AppQuotationCard from "../../component/app_quotation_card/app_quotation_card";
import App_table from "../../component/app_table/app_table";
import AppModal from "../../component/app_modal/app_modal";
import AppCardStatus from "../../component/app_card_status/app_card_status";
import UserAccessBloc from "../../../bloc/user_access_bloc";
import QuotationBloc from "../../../bloc/quotation_bloc";
import { Button } from "reactstrap";
import moment from "moment";
import AppSearchFilter2 from "../../component/app_filters/app_search_filter2";
import ProposalBloc from "../../../bloc/mrtt_proposal_bloc";

const MenulistIcon = (color) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 6H19C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z" fill={color.color} />
            <path d="M5 20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18H5C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z" fill={color.color} />
            <path d="M19 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13Z" fill={color.color} />
        </svg>
    )
}

const GridIcon = (color) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.20779 2H9.4026C10.6219 2 11.6104 2.98846 11.6104 4.20779V9.4026C11.6104 10.6219 10.6219 11.6104 9.4026 11.6104H4.20779C2.98846 11.6104 2 10.6219 2 9.4026V4.20779C2 2.98846 2.98846 2 4.20779 2ZM4.20779 3.81818C3.99262 3.81818 3.81818 3.99262 3.81818 4.20779V9.4026C3.81818 9.61777 3.99262 9.79221 4.20779 9.79221H9.4026C9.61777 9.79221 9.79221 9.61777 9.79221 9.4026V4.20779C9.79221 3.99262 9.61777 3.81818 9.4026 3.81818H4.20779ZM14.5974 12.3896H19.7922C21.0115 12.3896 22 13.3781 22 14.5974V19.7922C22 21.0115 21.0115 22 19.7922 22H14.5974C13.3781 22 12.3896 21.0115 12.3896 19.7922V14.5974C12.3896 13.3781 13.3781 12.3896 14.5974 12.3896ZM14.5974 14.2078C14.3822 14.2078 14.2078 14.3822 14.2078 14.5974V19.7922C14.2078 20.0074 14.3822 20.1818 14.5974 20.1818H19.7922C20.0074 20.1818 20.1818 20.0074 20.1818 19.7922V14.5974C20.1818 14.3822 20.0074 14.2078 19.7922 14.2078H14.5974ZM14.5974 2H19.7922C21.0115 2 22 2.98846 22 4.20779V9.4026C22 10.6219 21.0115 11.6104 19.7922 11.6104H14.5974C13.3781 11.6104 12.3896 10.6219 12.3896 9.4026V4.20779C12.3896 2.98846 13.3781 2 14.5974 2ZM14.5974 3.81818C14.3822 3.81818 14.2078 3.99262 14.2078 4.20779V9.4026C14.2078 9.61777 14.3822 9.79221 14.5974 9.79221H19.7922C20.0074 9.79221 20.1818 9.61777 20.1818 9.4026V4.20779C20.1818 3.99262 20.0074 3.81818 19.7922 3.81818H14.5974ZM4.20779 12.3896H9.4026C10.6219 12.3896 11.6104 13.3781 11.6104 14.5974V19.7922C11.6104 21.0115 10.6219 22 9.4026 22H4.20779C2.98846 22 2 21.0115 2 19.7922V14.5974C2 13.3781 2.98846 12.3896 4.20779 12.3896ZM4.20779 14.2078C3.99262 14.2078 3.81818 14.3822 3.81818 14.5974V19.7922C3.81818 20.0074 3.99262 20.1818 4.20779 20.1818H9.4026C9.61777 20.1818 9.79221 20.0074 9.79221 19.7922V14.5974C9.79221 14.3822 9.61777 14.2078 9.4026 14.2078H4.20779Z" fill={color.color} />
        </svg>
    )
}


class QuotationScreen extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.containerRef = React.createRef();
        this.contentRef = React.createRef();
        this.state = {
            loading: false,
            route: routeParams,
            client: Config.context,
            userData: null,
            placeholderOverview: this.props.dateFilterGlobal?.overallDateValue
                ? this.props.dateFilterGlobal.overallDateValue
                : "",
            fromDate: '2000-01-01',
            toDate: new Date(),
            sortingCriteria: 'cms_createdOn',
            filterCriteriaSetting: '',
            sortingCriteriaOptions: {
                captions: ['Creation Date', 'Last Updated'],
                values: ['cms_createdOn', 'cms_updatedOn'],
                default: 'Creation Date',
                defaultPlaceholder: 'Creation Date'
            },
            sortOrder: 'DESC',
            displayType: 'grid',
            sortOptions: [
                {
                    captions: 'Recent - Oldest',
                    values: 'DESC',
                },
                {
                    captions: 'Oldest - Recent',
                    values: 'ASC'
                },
            ],
            selectedStatus: this.props.match.params.status || 'ALL',
            keyword: '',
            quotationList: '',
            quotationAllCount: null,
            quotationDraftCount: null,
            quotationGeneratedCount: null,
            quotationPendingCount: null,
            initiatedStatus: false,
            currentPage: 1,
            startItem: 1,
            endItem: 1,
            totalPage: 0,
            limitItem: 0,
            selectedQuotationId: null,
            isDeleteModalOpen: false,
            isModalOpen: false,
            privacyPolicyStep: 1,
            isPrivacyPolicyScrollToEnd: false,
            checkScrollable: false,
            collectInformation: false,
            setObserver: false
        };
    }


    componentDidMount() {
        this.getDateRangeFilter();
        this.getUserData();
        this.getQuotationCount();
        this.getQuotationList();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.privacyPolicyStep !== this.state.privacyPolicyStep && this.state.privacyPolicyStep === 2 && this.state.setObserver === false) {
            this.setState({ setObserver: true });
            this.observer.observe(document.querySelector('#end-of-list'));
        }
    }

    observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            this.setState({ isPrivacyPolicyScrollToEnd: true })
        }
    }, { threshold: 0.1 });

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    async getUserData() {
        let userData = await UserAccessBloc.getUserData();
        this.setState({ userData: userData });
    }

    async getQuotationList() {
        this.setState({ loading: true });
        let userData = await UserAccessBloc.getUserData();
        let sourceChannel = await this.getSelectedBank();
        let listArr = [];
        let quotationDataList = await QuotationBloc.getListingData(
            userData.username,
            // 'SHA002',
            'quotation',
            this.state.sortingCriteria,
            this.state.sortOrder,
            moment(this.state.fromDate).format('YYYY-MM-DD HH:SS:MM'),
            moment(this.state.toDate).format('YYYY-MM-DD 23:59:59'),
            (this.state.selectedStatus != 'GENERATED' && this.state.selectedStatus != 'INITIATED') ? 'ALL' : this.state.selectedStatus,
            this.state.currentPage - 1 || 0,
            this.state.keyword || '',
            sourceChannel
        )
        if (quotationDataList.success) {
            quotationDataList.data.map(async (item) => {
                listArr.push(item.quotation);

            })
            this.setState({
                quotationList: listArr,
                totalPage: quotationDataList.page?.pageCount || 0,
                totalItem: quotationDataList.page?.total || 0,
                limitItem: quotationDataList.page?.limit || 0,
                startItem: (quotationDataList.page?.start || 0) + 1,
                endItem: (quotationDataList.page?.end || 0) + 1
            })
        } else {
            this.setState({
                isError: true,
                errorMessage: 'Failed to get quotation list',
                title: 'Error'
            })
        }
        this.setState({ loading: false });
    }

    async getQuotationCount() {
        this.setState({ loading: true });
        let userData = await UserAccessBloc.getUserData();
        let sourceChannel = await this.getSelectedBank();
        let dataListingCount = await QuotationBloc.getListingCountData(
            userData.username,
            // 'SHA002',
            'quotation',
            this.state.dateFilter,
            moment(this.state.fromDate).format('YYYY-MM-DD HH:SS:MM'),
            moment(this.state.toDate).format('YYYY-MM-DD 23:59:59'),
            sourceChannel
        );

        if (dataListingCount) {
            this.setState({
                quotationAllCount: dataListingCount.data.all,
                quotationDraftCount: dataListingCount.data.draft,
                quotationGeneratedCount: dataListingCount.data.generated,
                quotationPendingCount: dataListingCount.data.pending,
            })
        }
        this.setState({ loading: false });
    }

    async handleEditQuotation(id) {
        let userData = UserAccessBloc.getUserData();
        this.setState({ loading: true });
        let response = await QuotationBloc.editGeneratedQuotation(id);
        if (response.success) {
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}/${id}`
        } else {
            this.setState({
                isError: true,
                errorMessage: 'This quotation cannot be edit.'
            })
        }
        this.setState({ loading: false });
    }

    async handleDeleteQuotation(id) {
        let userData = UserAccessBloc.getUserData();
        let response = await QuotationBloc.deleteQuotationById(id);
        if (response.success) {
            this.setState({
                isDeleteModalOpen: false
            })
            this.getQuotationList()
        } else {
            this.setState({
                isError: true,
                title: 'Error',
                errorMessage: 'Quotation delete failed.'
            })
        }
    }

    init() {
        // this.setState({ loading: true });
        // this.getQuotationCount();
        // this.getQuotationList();
        this.setState({ loadoing: false });
    }

    handleGoBackToDashboard = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.home}`
    }

    getFilterStatus() {
        return this.props.match.params.status;
    }

    getDateRangeFilter = () => {
        let dateRangeOverallSetting = {
            captions: ['All Time', 'Last 30 Days', 'Last 60 Days', 'Custom'],
            codes: ['All', '30', '60', 'range'],
            default: 'All',
            defaultPlaceholder: 'All Time'
        }

        this.setState({
            dateRangeOverall: dateRangeOverallSetting,
            dateFilter:
                dateRangeOverallSetting.codes[0] ||
                dateRangeOverallSetting.default,
            placeholderOverview:
                dateRangeOverallSetting.captions[0] ||
                dateRangeOverallSetting.defaultPlaceholder,
        });
    }

    handleFilterDate = (dateValue) => {
        let today = moment();
        let fromDate = '';
        let toDate = '';
        if (dateValue == 'All') {
            fromDate = '2000-01-01'
            toDate = today.format('YYYY-MM-DD')
        } else if (dateValue != "range") {
            fromDate = today.subtract(dateValue, 'day').format('YYYY-MM-DD')
            toDate = moment().format('YYYY-MM-DD')
        }
        this.setState({
            dateFilter: dateValue,
            fromDate: fromDate,
            toDate: toDate,
            currentPage: 1
        }, () => {
            this.getQuotationList();
            this.getQuotationCount();
        });
    }

    handleDateRange = (dateRange) => {
        let fromDate = dateRange ? dateRange[0] : null;
        let toDate = dateRange ? dateRange[1] : null;

        this.setState(
            {
                ...this.state,
                fromDate: fromDate,
                toDate: toDate,
                currentPage: 1
            }, () => {
                this.getQuotationList();
                this.getQuotationCount();
            }
        );
    }

    handleFilterListByStatus = (status) => {
        let currentStatus = this.state.selectedStatus == status ? 'ALL' : status;

        this.setState({ selectedStatus: currentStatus, currentPage: 1 }, () => {
            this.getQuotationList();
        });

    }

    handleSortingCriteriaChange = (sort) => {
        this.setState({ sortingCriteria: sort, currentPage: 1 }, () => {
            this.getQuotationList();
        });
    }

    handleSortOrderChange = (order) => {
        this.setState({ sortOrder: order, currentPage: 1 }, () => {
            this.getQuotationList();
        })
    }

    handleOnClickSearch = () => {
        console.log("searching")
    }

    handleChangeKeyword = (keyword) => {
        this.setState({ keyword: keyword, currentPage: 1 }, () => {
            this.getQuotationList();
        })
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page }, () => {
            this.getQuotationList();
        });
    }

    handlePrivacyModalOpen = () => {
        this.setState({ isModalOpen: true })
    }

    handlePrivacyModalClose = () => {
        this.setState({ isModalOpen: false })
    }

    handleDeleteModalOpen = () => {
        this.setState({ isDeleteModalOpen: true })
    }

    handleDeleteModalClose = () => {
        this.setState({ isDeleteModalOpen: false })
    }

    async handleCreateNewQuotation() {
        let bankID = this.getSelectedBank();
        let collectInformation=this.state.collectInformation;
        let result = await QuotationBloc.createNewQuotation(await bankID,collectInformation);
        window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}/${result}`;
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop >= e.target.clientHeight;
        if (bottom) {
            this.setState({ isPrivacyPolicyScrollToEnd: true })
        }
    }


    columns = [
        {
            title: 'Ref No.',
            dataIndex: 'refNo',
            key: 'ref',
            //   render: (text) => <a>{text}</a>,
        },
        {
            title: 'Client Name',
            dataIndex: 'fullName',
            key: 'name',
        },
        {
            title: 'ID No.',
            dataIndex: 'idNo',
            key: 'id',
        },
        {
            title: 'Creation Date',
            dataIndex: 'cms_createdOn',
            key: 'createdDate',
            render: (cms_createdOn) => (
                <>{moment(cms_createdOn).format('DD/MM/YYYY')}</>
            ),
        },
        {
            title: 'Last Updated',
            dataIndex: 'cms_updatedOn',
            key: 'lastUpdate',
            render: (cms_updatedOn) => (
                <>{moment(cms_updatedOn).format('DD/MM/YYYY')}</>
            ),
        },
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'trxStatus',
            render: (_, { trxStatus }) => (
                <AppCardStatus
                    status={trxStatus}
                    module={"quotation"}
                />
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Dropdown
                    overlay={
                        <Menu
                            style={{
                                marginTop: "12px",
                                width: '200px'
                            }}
                            items={this.getDropDownItem(_, _.trxStatus)}
                        />
                    }
                    trigger={["click"]}
                    className="header__profile"
                >
                    <Button type="text"
                        style={{ backgroundColor: 'transparent', border: '0px', boxShadow: 'none' }}
                        onClick={(e) => e.stopPropagation()}>
                        <ThreeDotsIcon className="" />
                    </Button>
                </Dropdown>

            ),
        },
    ];

    getQuotationStatus = (status) => {
        let quotationStatus = ''
        status === 'Proposal Proceeded' ? quotationStatus = 'GENERATED' :
            status === 'Quotation Created' ? quotationStatus = 'PENDING' :
                status === 'Draft' ? quotationStatus = 'DRAFT' :
                    quotationStatus = status;

        return quotationStatus;
    }

    handleOnDropDownItemClick = (opt, data) => {
        if (opt === 'View') {
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_details}/${data.id}`;
        }
        if (opt === 'Edit' || opt === 'Update') {
            this.handleEditQuotation(data.id)
        }
        if (opt === 'Delete') {
            this.setState({ selectedQuotationId: data.id });
            this.handleDeleteModalOpen();
        }
        if (opt === 'Proceed to Proposal') {
            this.handleGoCreateProposal(data.id);
        }
        if (opt === 'Update Proposal') {
            this.handleUpdateProposal(data);
        }
        if (opt === 'Update Quotation') {
            this.handleEditQuotation(data.id);
        }
        if (opt === 'View Proposal') {
            this.handleViewProposal(data);
        }
        if (opt === 'View Quotation') {
            this.handleViewQuotation(data);
        }
    }

    handleViewQuotation = (data) => {
        if (data.status == 'DRAFT') {
            this.handleEditQuotation(data.id)
        } else {
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_details}/${data.id}`
        }
    }

    handleViewProposal = (data) => {
        window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_details}/${data.reference1}`
    }

    async handleUpdateProposal(data) {
        // reference1 === proposal id
        let response = await ProposalBloc.editGeneratedProposal(data.reference1);
        if (response.success) {
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}/${data.reference1}`
        } else {
            this.setState({
                isError: true,
                errorMessage: 'This proposal cannot be edit.'
            })
        }
    }

    async getSelectedBank(sourceChannel = null) {
        let selectedBank = await JSON.parse(sessionStorage.getItem("selectedBank"))?.id || this.props?.userGlobal?.roles[0]?.entity;
        if (selectedBank !== 'MBS' && sourceChannel) {
            selectedBank = sourceChannel;
        }
        return selectedBank;
    }

    async handleGoCreateProposal(id, sourceChannel = null) {
        this.setState({ loading: true });
        let generateQuotation = await QuotationBloc.generateQuotation(id);
        if (generateQuotation.success) {
            let result = await ProposalBloc.createNewProposal({ id: id, sourceChannel: await this.getSelectedBank(sourceChannel) === "MBS" ? "MBS": "AIS" });
            if (result.success) {
                window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}/${result.data[0].proposal.id}`
            } else {
                this.setState({
                    title: 'Error',
                    isError: true,
                    errorMessage: 'Failed to create Proposal'
                })
            }
        } else {
            this.setState({
                title: 'Error',
                isError: true,
                errorMessage: 'Failed to generate Quotation'
            })
        }
        this.setState({ loading: false });
    }

    getDropDownItem(quotationData, status) {
        let dropdownitem = Config.quotation.actions[this.getQuotationStatus(status)].labels;
        let item = [];

        if (this.getQuotationStatus(status) == 'GENERATED' &&
            (quotationData?.proposalDetail?.trxStatus == 'PENDING_SUBMISSION' || quotationData?.proposalDetail?.trxStatus == 'SUBMITTED')
        ) {
            dropdownitem = Config.quotation.actions.PENDING_SUBMITTED.labels
        }

        dropdownitem && dropdownitem.map((data, idx) => {
            item.push(
                {
                    label: (
                        <div
                            onClick={() => this.handleOnDropDownItemClick(data, quotationData)}
                            className="dropdown_item"
                        >
                            {data}
                        </div>

                    ),
                    key: idx
                }
            )
        })

        return item;
    }

    async getProposalDetailByQuotation(proposalId) {
        let result = await ProposalBloc.getProposalDetail(proposalId, (this.state.userData.username || await UserAccessBloc.getUserData().username)); //'SHA002'
        if (result) {
            return result.status;
        }
    }

    renderToolBar = () => {
        return (
            <div className="d-flex">
                <div style={{ width: '21%' }}>
                    <App_dropdown_filter
                        width={'100%'}
                        onSelectedDateFilter={this.handleFilterDate}
                        dataDateByCaption={this.state.dateRangeOverall?.captions || []}
                        dataDateByValue={this.state.dateRangeOverall?.codes || []}
                        placeholder={this.state.placeholderOverview}
                    />

                </div>
                <div style={{ width: '21%' }}>
                    <App_daterange_filter
                        width={'100%'}
                        isNotRange={this.state.dateFilter != "range"}
                        defaultValueFromDate={this.state.fromDate}
                        defaultValueToDate={this.state.toDate}
                        value={[this.state.fromDate, this.state.toDate]}
                        disabled={this.state.dateFilter == "range" ? false : true}
                        onSelectedDateRange={this.handleDateRange}
                    />
                </div>
                <div className="ml-2" style={{ width: '13%' }}>
                    <AppDropdownFilter3
                        options={this.state.sortingCriteriaOptions}
                        onSelectedOptions={this.handleSortingCriteriaChange}
                        default={this.state.sortingCriteria}
                        value={this.state.sortingCriteria}
                    />
                </div>
                <div className="ml-2" style={{ width: '15%' }}>
                    <AppDropdownSort
                        options={this.state.sortOptions}
                        onSelectedOptions={this.handleSortOrderChange}
                        default={this.state.sortOptions[0].captions}
                    />
                </div>
                <div className="ml-2 row" style={{ width: '8%' }}>
                    <Button
                        className="w-50 quotation_container_border h-100 p-0"
                        style={{ backgroundColor: '#FFFFFF', border: '1px solid rgba(224, 224, 224, 1)', borderRadius: 0, boxShadow: 'none' }}
                        onClick={() => this.setState({ displayType: 'list' })}
                    >
                        <MenulistIcon color={this.state.displayType === 'list' ? "#EE7623" : "#92929D"} />
                    </Button>
                    <Button
                        className="w-50 quotation_container_border h-100 p-0"
                        style={{ backgroundColor: '#FFFFFF', border: '1px solid rgba(224, 224, 224, 1)', borderRadius: 0, boxShadow: 'none' }}
                        onClick={() => this.setState({ displayType: 'grid' })}
                    >
                        <GridIcon color={this.state.displayType === 'grid' ? "#EE7623" : "#92929D"} />
                    </Button>
                </div>
                <div className="ml-2 row" style={{ width: '22%' }}>
                    <AppSearchFilter2
                        title={"Search by reference number/client name..."}
                        onChangeKeyword={this.handleChangeKeyword}
                        onClickSearch={this.handleOnClickSearch}
                    />
                </div>

            </div>
        )
    }

    renderGridList = () => {
        return (
            <>
                <div className="row px-2" style={{ rowGap: '1%', columnGap: '1%' }}>
                    {
                        this.state.quotationList && this.state.quotationList.map((data) => {
                            return (
                                <AppQuotationCard
                                    name={data?.fullName || 'N/A'}
                                    id={data.id}
                                    status={data.trxStatus}
                                    refNo={data.refNo}
                                    idNo={data.idNo}
                                    data={data}
                                    createdDate={moment(data.cms_createdOn).format('DD/MM/YYYY')}
                                    lastUpdated={moment(data.cms_updatedOn).format('DD/MM/YYYY')}
                                    handleDelete={(id) => this.handleDeleteQuotation(id)}
                                    handleEditQuotation={(id) => this.handleEditQuotation(id)}
                                    handleEditProposal={(id) => this.handleUpdateProposal(id)}
                                    handleProceedProposal={(id, sourceChannel) => this.handleGoCreateProposal(id, sourceChannel)}
                                    getDropDownItem={(data, status) => this.getDropDownItem(data, status)}
                                    props={this.props}
                                    module={'quotation'}
                                    showMenu={true}
                                />
                            )
                        })
                    }
                </div>
                <div
                    style={{ padding: 16 }}
                    className="align-items-center d-flex  w-100"
                >
                    {/* {this.props.data.length ? ( */}
                    <>
                        <div style={{ width: "40%" }}>
                            {this.state.startItem} -{" "}
                            {this.state.endItem} of{" "}
                            {
                                this.state.selectedStatus === 'INITIATED' ? (this.state.quotationPendingCount?.page.total + this.state.quotationDraftCount?.page.total) :
                                    this.state.selectedStatus === Config.quotation.statusMapping.GENERATED.label ? this.state.quotationGeneratedCount?.page.total :
                                        this.state.quotationAllCount?.page.total
                            } items
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="page_title_paggination">Page</div>
                            <Pagination
                                current={this.state.currentPage || 1}
                                total={
                                    this.state.selectedStatus === 'INITIATED' ? (this.state.quotationPendingCount?.page.total + this.state.quotationDraftCount?.page.total) :
                                        this.state.selectedStatus === Config.quotation.statusMapping.GENERATED.label ? this.state.quotationGeneratedCount?.page.total :
                                            this.state.quotationAllCount?.page.total
                                }
                                onChange={(e) => this.handlePageChange(e)}
                                style={{ bottom: "0px", width: "100%" }}
                                nextIcon={<RightArrowIcon />}
                                prevIcon={<LeftArrowIcon />}
                                pageSize={12}
                                pageSizeOptions={[12]}
                                showLessItems
                                size="default"
                            />
                            <div
                                className="page_total_paggination"
                            >
                                of {Math.ceil((
                                    this.state.selectedStatus === 'INITIATED' ? (this.state.quotationPendingCount?.page.total + this.state.quotationDraftCount?.page.total) :
                                        this.state.selectedStatus === Config.quotation.statusMapping.GENERATED.label ? this.state.quotationGeneratedCount?.page.total :
                                            this.state.quotationAllCount?.page.total
                                ) / 12)}
                            </div>
                        </div>
                        <div></div>
                    </>
                    {/* ) : null} */}
                </div>
            </>
        )
    }

    renderTableList = () => {
        return (
            <div className="w-100">
                <App_table
                    data={this.state.quotationList || ''}
                    collumn={this.columns}
                    totalData={this.state.selectedStatus === "ALL" ? this.state.quotationAllCount?.page.total : (this.state.quotationPendingCount?.page.total + this.state.quotationDraftCount?.page.total)}
                    onSelectedPage={this.handlePageChange}
                    currentPage={this.state.currentPage}
                    handleOnClick={this.handleViewQuotation}
                    pagination={true}
                />
            </div>
        )
    }

    renderPrivacyNoticeContent = () => {
        return (
            <>
                <div className="mt-4 px-3">
                    <div className="quotation_privacy_title">
                        Person to be Covered’s Acknowledgement
                    </div>
                    <ol className="p-3 ml-2" style={{ textAlign: 'left', fontSize: 16 }}>
                        <li className="mb-2">Your representative must have sufficient information before making a suitable recommendation. The information that you provide will be the basis of which advice will be given. </li>
                        <li className="mb-2">Your representative is required to preserve the confidentiality of information you have disclosed and restrict the use of such information solely for the purpose of this mortgage application.  </li>
                        <li className="mb-2">You must ensure that all information regarding this mortgage plan is disclosed to you, and you fully understand the information disclosed. Where there is ambiguity, you should seek an explanation from your representative.  </li>
                        <li className="mb-2">You must ensure that you have read and understand all terms and conditions above and reviewed Privacy Policy Summary  </li>
                    </ol>
                </div>
                <div className="mt-3 px-3">
                    <div className="quotation_privacy_title mb-2">
                        Sale’s Representations Declaration
                    </div>
                    <span style={{ fontSize: 16 }}>By clicking “Next”, I hereby certify that the above Privacy Notice has been read and agreed by the Person to be Covered in my presence.</span>
                </div>
                <div className="column mt-3 d-flex justify-content-end">
                    <Button
                        type='text'
                        style={{ color: '#FFFFFF', backgroundColor: '#183028', fontSize: 14, fontWeight: '600', width: 170, height: 40, borderRadius: 0 }}
                        className="d-flex align-items-center justify-content-center"
                        onClick={() => this.setState({ privacyPolicyStep: 2 })}
                    >
                        Next
                    </Button>
                </div>
            </>
        )
    }
    renderPrivacyPolicyContent = () => {
        let title = 'Personal Data Protection';
        return (
            <div>
                <div className="mt-4 px-3" style={{ height: '45vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} ref={this.containerRef} >
                    <div ref={this.contentRef} style={{ height: '50vh' }}>
                        <div className="quotation_privacy_policy_container d-flex">
                            <span className="quotation_privacy_policy_title">{title.toLocaleUpperCase()}</span>
                        </div>
                        <div className='p-3'>
                            <ol>
                                <li className="mt-3">
                                    I/We understand and agree that any personal information collected or held by FWD Takaful (whether contained in this application form or otherwise obtained) may be used, processed, disclosed and shared by FWD Takaful with individuals/organisations related to and associated with FWD Takaful or any selected third party (within or outside of Malaysia, including retakaful and claims investigation companies and industry associations/federations) for the purpose of processing this application form and providing subsequent services for this and other financial products and services and to communicate with me/us for said  purposes.
                                </li>
                                <li className="mt-3">
                                    I/We understand that I/we have a right to request access to my personal information held by FWD Takaful and to request correction of any incorrect personal information or the limitation of the processing of my personal information. I/We consent and hereby authorise FWD Takaful to charge a fee for processing and complying with such data access requests or correction requests.
                                </li>
                                <li className="mt-3">
                                    I/We further agree that a photocopy of this authorisation will be as effective and valid as the original.
                                </li>
                                <li className="mt-3">
                                    If you would like to receive information regarding any exclusive promotions and offers from FWD Takaful or third parties, please provide your consent by ticking the box below:
                                    <Checkbox
                                        onChange={(e) => this.setState({ collectInformation: e.target.checked })}
                                        checked={this.state.collectInformation}
                                    >
                                        I/We agree that any personal information collected or held by FWD Takaful (whether contained in this application form or otherwise obtained) may be used by FWD Takaful or disclosed by FWD Takaful to third parties for the purposes of direct marketing and to communicate with me/us for such purposes.
                                    </Checkbox>
                                </li>
                                <li className="mt-3">
                                    By submitting this application, I/we confirm that I/we have read and agreed to the Personal Data Protection Notice set out in the hyperlink: <span className="consent_declaration_color_text" style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.fwd.com.my/tkfl-personal-data-protection-notice/', '_blank')}>PDPA Notice</span>.
                                </li>
                            </ol>
                        </div>
                        <div id="end-of-list" style={{ height: '50px' }}></div>
                    </div>
                </div>
                {/* <div className="mt-3 px-3">
                    <div className="quotation_privacy_title mb-2">
                        Sale{'\''}s Representations Declaration
                    </div>
                    <span style={{ fontSize: 16 }}>
                        By clicking “Confirm”, I hereby certify that the above Personal Data Protection has been read and agreed by the Person to be Covered in my presence.
                    </span>
                </div> */}
                <div className="column mt-3 d-flex justify-content-end">
                    <Button
                        type='text'
                        style={{
                            color: '#FFFFFF',
                            backgroundColor: this.state.isPrivacyPolicyScrollToEnd ? '#183028' : '#A3ACA9',
                            fontSize: 14,
                            fontWeight: '600',
                            width: 170,
                            height: 40,
                            borderRadius: 0
                        }}
                        className="d-flex align-items-center justify-content-center"
                        onClick={() => this.state.isPrivacyPolicyScrollToEnd ? this.handleCreateNewQuotation() : ''}
                        // onClick={() => window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}`}
                        disabled={Boolean(!this.state.isPrivacyPolicyScrollToEnd)}
                    >
                        Confirm
                    </Button>
                </div>
            </div>
        )
    }

    render() {
        return (
            <>
                <div style={{ fontFamily: 'Lato' }}>
                    {this.state.loading && this.loadingContent()}
                    <BaseScreen
                        listener={(userSettings) => {
                            this.init();
                        }}
                    >
                        <App_header
                            data={this.state.userData}
                            route={this.state.route.entity}
                        />
                        <App_sidebar route={this.state.route.entity}>
                            <div className="row m-0 align-items-center">
                                <div className="col-9">
                                    <App_header_title_simple
                                        title="Quotation"
                                        handleBack={() => this.handleGoBackToDashboard()}
                                    />
                                </div>
                                <div className="col-3 d-flex justify-content-end align-items-center">
                                    <Button
                                        className="d-flex align-items-center quotation_link py-3"
                                        type="text"
                                        onClick={() => this.handlePrivacyModalOpen()}
                                        style={{
                                            backgroundColor: "#183028",
                                            padding: '1.5vh',
                                            borderRadius: 0,
                                            color: '#ffffff',
                                        }}
                                    >
                                        <PlusIcon className="mr-2" fill="white" />
                                        <span className="quotationscreen_link_text">Create New Quotation</span>
                                    </Button>
                                </div>
                            </div>
                            <div className="mt-4">
                                {this.renderToolBar()}
                            </div>
                            <div className="quotation_status_container">
                                <div
                                    className={
                                        (this.state.selectedStatus === Config.quotation.statusMapping.GENERATED.label || this.state.selectedStatus === "ALL") ?
                                            "quotation_status_proceeded" : "quotation_status_initiated"
                                    }
                                    onClick={() => this.handleFilterListByStatus(Config.quotation.statusMapping.GENERATED.label)}
                                >
                                    {this.state.quotationGeneratedCount?.page.total || 0} <span className="quotationscreen_text">Proposal Proceeded </span>
                                </div>

                                <div
                                    className={
                                        (this.state.selectedStatus === 'INITIATED' || this.state.selectedStatus === "ALL") ?
                                            "quotation_status_initiated_filter" : "quotation_status_initiated"
                                    }
                                    onClick={() => this.handleFilterListByStatus('INITIATED')}
                                >
                                    {(this.state.quotationPendingCount?.page.total + this.state.quotationDraftCount?.page.total) || 0}
                                    <span className="quotationscreen_text">Initiated</span>
                                </div>

                            </div>
                            <div className="my-3">
                                Showing
                                <b className="px-1">
                                    {
                                        this.state.selectedStatus === 'INITIATED' ? (this.state.quotationPendingCount?.page.total + this.state.quotationDraftCount?.page.total) :
                                            this.state.selectedStatus === Config.quotation.statusMapping.GENERATED.label ? this.state.quotationGeneratedCount?.page.total :
                                                this.state.quotationAllCount?.page.total
                                    }
                                </b> result
                            </div>
                            {this.state.displayType === 'list' && this.renderTableList()}
                            {this.state.displayType === 'grid' && this.renderGridList()}
                        </App_sidebar >
                    </BaseScreen>
                </div >
                <AppModal
                    open={this.state.isError}
                    closable={false}
                    title={this.state.title}
                    subtitle={this.state.errorMessage}
                    positiveButtonText={'OK'}
                    handleModalClose={() => { this.setState({ isError: false }) }}
                    handlePositivePress={() => this.setState({ isError: false })}
                />
                <AppModal
                    open={this.state.isModalOpen}
                    handleModalClose={this.handlePrivacyModalClose}
                    width={'70%'}
                    title={this.state.privacyPolicyStep === 1 ? 'Privacy Notice' : 'Personal Data Protection'}
                    subtitle={'Last Updated on 30 Jan 2024'}
                >
                    {
                        this.state.privacyPolicyStep === 1 ? this.renderPrivacyNoticeContent() : this.renderPrivacyPolicyContent()
                    }
                </AppModal>
                <AppModal
                    open={this.state.isDeleteModalOpen}
                    handleModalClose={this.handleDeleteModalClose}
                    width={'50%'}
                    title={'Do you want to delete this quotation ?'}
                    negativeButtonText={'Cancel'}
                    positiveButtonText={'Yes, Delete'}
                    handleNegativePress={this.handleDeleteModalClose}
                    handlePositivePress={() => this.handleDeleteQuotation(this.state.selectedQuotationId)}
                >
                    <span style={{ fontSize: 16, color: '#808EA8' }}>If you delete this quotation, you wil loose any progress you’ve made.</span>
                </AppModal>

            </>
        );
    }
}
const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
});

const mapDispatchToProps = { setFilterBy };

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(QuotationScreen)
);